import { splitWords } from '../../widgets/utils';
import { CanvasObject } from './CanvasObject';
import { Controller } from './Controller';
import { Ring } from './Ring';
import { IBlock } from './temp';


export class Box extends CanvasObject<IBlock> {

  private color = '#ffc';
  private selectedColor = '#ccffda';
  private mouseDistance: number;
  private padding: number = 24;
  private lineHeight: number = 30;

  constructor(
    c: CanvasRenderingContext2D,
    private width: number,
    private height: number,
    protected _x: number,
    protected _y: number,
    private dx: number,
    private dy: number,
    private ring: Ring,
    public meta: IBlock
  ) {
    super(_x, _y, meta);
    this.ring.draw(c);
    this.mouseDistance = 0;
  }

  public draw(c: CanvasRenderingContext2D, controller: Controller) {
    const {width, height, x, y, lineWidth, lineHeight, lines} = this.dimensions(c);
    c.beginPath();

    let color = this.color;
    if (controller.selected && controller.selected.meta.id === this.meta.id) {
      color = this.selectedColor;
    }
    if (controller.link && controller.link.meta.id === this.meta.id) {
      color = this.selectedColor;
    }

    c.fillStyle = color;
    c.shadowColor = color;
    c.shadowBlur = 10;
    c.fillRect(x, y, width, height);
    // c.fill();

    c.beginPath();
    c.font = `12px Arial`;
    c.fillStyle = '#000';
    lines.forEach((line, i: number) => {
      c.fillText(line, lineWidth(i), lineHeight(i));
    });
    c.fill();

    // c.beginPath();
    // c.font = `12px arial`;
    // const mouse = {
    //   x: typeof controller.mouse.x === 'number' ? controller.mouse.x : 0,
    //   y: typeof controller.mouse.y === 'number' ? controller.mouse.y : 0,
    // }
    // c.fillText(`Box: (${this.x.toFixed(0)},${this.y.toFixed(0)}) Mouse: (${mouse.x?.toFixed(0)},${mouse.y?.toFixed(0)})`, this.x, this.y - ((this.height / 2) + 12));
    // c.fill();
    //
    // c.beginPath();
    // c.strokeStyle = 'red';
    // c.rect(x, y, width, height);
    // c.stroke();
  }

  public update(controller: Controller, canvas: HTMLCanvasElement, c: CanvasRenderingContext2D) {
    const {width, height, x, y, lineWidth, lineHeight, lines} = this.dimensions(c);
    // Collision
    const [xMin, xMax] = controller.boundary.x;
    const [yMin, yMax] = controller.boundary.y;
    if (this.x + width >= xMax || this.x - width <= xMin) {
      this.dx = -this.dx;
    }

    if (this.y + height >= yMax || this.y - height <= yMin) {
      this.dy = -this.dy;
    }

    this.x += this.dx;
    this.y += this.dy;

    const within = (_x: number, _y: number) => {
      // Must be between (x' - MouseDistance) and (x' + width + MouseDistance)
      // x > (x' - MouseDistance) && x < (x' + width + MouseDistance)
      const withinX = _x > (x - this.mouseDistance) && _x < (x + width + this.mouseDistance);
      const withinY = _y > (y - this.mouseDistance) && _y < (y + height + this.mouseDistance);
      return withinX && withinY;
    };
    // mouse interactivity
    if (typeof controller.mouse.x === 'number' && typeof controller.mouse.y === 'number') {
      if (controller.selected && controller.selected.meta.id === this.meta.id) {
        // If this block is the selected block, then start moving it
        this._x = controller.mouse.x;
        this._y = controller.mouse.y;
      }
      if (within(controller.mouse.x, controller.mouse.y) && this.ring.radius < this.ring.radiusTarget) {
        this.ring.expand();
      } else if (this.ring.radius > this.ring.initialRad) {
        this.ring.shrink();
      }
    }

    // mouse click
    if (typeof controller.click.x === 'number' && typeof controller.click.y === 'number') {
      if (within(controller.click.x, controller.click.y)) {
        controller.clickObject(this);
      } else {
        // console.error('Could not click node')
      }
    }

    this.draw(c, controller);
    this.ring.update(c, this.x, this.y, width/2);
  }

  private dimensions(c: CanvasRenderingContext2D) {
    let width = 0;
    const lines: string[] = splitWords(`${this.meta.name}\n\n${this.meta.description}`, 15);
    lines.forEach((line, i: number) => {
      const m = c.measureText(line);
      const _width = m.width + (this.padding * 2)
      if (_width > width) {
        width = _width;
      }
    });
    const height = lines.length * 15 + 8;
    return {
      x: (this.x - (width / 2) - this.padding),
      y: (this.y - (height / 2) - this.padding),
      width: width + (this.padding * 2),
      height: height + (this.padding * 2),
      lineHeight: (i: number) => this.y - (height / 2) + (i * this.lineHeight) + 4,
      lineWidth: (i: number) => this.x - (width / 2) + 4,
      lines: lines
    }
  }

}
